import {
  SET_PRODUCTS,
  CHECK_IF_EAN_ALREADY_PRESENT,
  ADD_PRODUCTS_ERRORS,
  ADD_PRODUCTS_WARNING,
  DELETE_PRODUCT,
  OPEN_REVIEW_PRODUCT_DIALOG,
  CLOSE_REVIEW_PRODUCT_DIALOG,
  SET_PRODUCTS_ARE_IN_STOCK,
  RESET_IMPORT_PRODUCTS,
  GET_BARCODE_VALUES_SUCCESS,
  GET_REQUIRED_ATTRIBUTES,
  GET_REQUIRED_ATTRIBUTES_SUCCESS,
  HANDLE_LOADER,
  CREATE_STOCK_BATCH_SUCCESS,
  OPEN_DELETE_PRODUCT_DIALOG,
  CLOSE_DELETE_PRODUCT_DIALOG
} from './actions';
import { GET_REQUIRED_ATTRIBUTES_FAILURE } from '../../stock/stockActions';

const initialState = {
  products: [],
  currentProduct: {},
  requiredAttributes: [],
  barcodeValues: [],
  openReviewProductDialog: false,
  index: 0,
  loadingImport: false,
  eanIsInStock: [],
  eanInFile: [],
  productsWithErrors: [],
  productsIds: [],
  openDeleteDialog: false
};

export default function importProductReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_IMPORT_PRODUCTS:
      return { ...initialState };
    case SET_PRODUCTS:
      return {
        ...state,
        products: action.data,
        eanInFile: action.data
      };
    case CHECK_IF_EAN_ALREADY_PRESENT:
      return {
        ...state,
        eanIsInStock: action.payload
      };
    case ADD_PRODUCTS_ERRORS:
      return {
        ...state,
        products: state.products.map((product, index) => ({
          ...product,
          errorsItem:
            index === action.payload.index
              ? action.payload.fullErrors
              : product.errorsItem
        }))
      };
    case ADD_PRODUCTS_WARNING:
      return {
        ...state,
        products: action.payload
      };
    case DELETE_PRODUCT:
      return {
        ...state,
        products: state.products.filter(
          (product, index) => index !== action.data
        )
      };
    case SET_PRODUCTS_ARE_IN_STOCK:
      return {
        ...state,
        productsAreInStock: action.data
      };
    case OPEN_REVIEW_PRODUCT_DIALOG:
      return {
        ...state,
        openReviewProductDialog: true,
        currentProduct: action.payload,
        index: action.index
      };
    case OPEN_DELETE_PRODUCT_DIALOG:
      return {
        ...state,
        openDeleteDialog: true,
        currentProduct: action.payload,
        index: action.index
      };
    case CLOSE_DELETE_PRODUCT_DIALOG:
      return {
        ...state,
        openDeleteDialog: false,
        currentProduct: {},
        index: 0
      };
    case CLOSE_REVIEW_PRODUCT_DIALOG:
      return {
        ...state,
        openReviewProductDialog: false,
        products: state.products.map((product, index) => {
          if (index !== state.index) {
            return product;
          }
          return {
            ...product,
            ...action.payload
          };
        }),
        currentProduct: {}
      };
    case CREATE_STOCK_BATCH_SUCCESS:
      return {
        ...state,
        productsIds: action.data.commandsIds,
        createStockBatchSuccess: true
      };
    case HANDLE_LOADER:
      return {
        ...state,
        loadingImport: action.data
      };
    case GET_BARCODE_VALUES_SUCCESS:
      return {
        ...state,
        barcodeValues: action.payload.barcodeValues
      };
    case GET_REQUIRED_ATTRIBUTES:
      return {
        ...state,
        loading: false
      };
    case GET_REQUIRED_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        requiredAttributes: action.payload.requiredAttributes
      };
    case GET_REQUIRED_ATTRIBUTES_FAILURE:
      return {
        ...state
      };
    default:
      return {
        ...state
      };
  }
}
